import React from "react";

export default class BrowserData {
  static sharedInstance = BrowserData.getInstance();

  static createInstance() {
    const object = new BrowserData();
    return object;
  }

  static getInstance() {
    if (!BrowserData.instance) {
      BrowserData.sharedInstance = BrowserData.createInstance();
    }
    return BrowserData.sharedInstance;
  }

  static set(key, data) {
    const value = typeof data === "object" ? JSON.stringify(data) : data;
    localStorage.setItem(key, value);
  }

  static get(key) {
    try {
      return JSON.parse(localStorage.getItem(key));
    } catch (e) {
      return localStorage.getItem(key);
    }
  }

  static clear() {
    localStorage.clear();
  }
}
